import React from 'react';
import { useAccountingCycleId } from '../shared/useAccountingCycleRouting';
import useAccountingCycle from '../useAccountingCycle';
import { Show } from 'framework/show';
import ViewAccountingCycleContent from './ViewAccountingCycleContent';

const ShowAccountingCycle = () => {
  const { getById } = useAccountingCycle();
  const id = useAccountingCycleId();
  return (
    <Show getDataMethod={() => getById(id)}>
      <ViewAccountingCycleContent />
    </Show>
  );
};

export default ShowAccountingCycle;
